module.exports = __webpack_public_path__ + "img/9.24e483f5.jpg";